import { CardStylesType } from "./consts";

export const cardStyles: CardStylesType = {
  default: {
    base: {
      "color": "#000000",
      "fontFamily": "proxima-nova, sans-serif",
      "fontSize": "16px",
      "lineHeight": "24px",
      "backgroundColor": "white",
      "::placeholder": {
        color: "#aaaaaa",
      },
      ":disabled": {
        color: "#9E9E9E",
      },
    },
    invalid: {
      color: "#EF372A",
      iconColor: "#EF372A",
    },
  },
  AHSRebrand: {
    base: {
      "color": "#424242",
      "fontFamily": "Onest, sans-serif",
      "fontSize": "16px",
      "lineHeight": "24px",
      "backgroundColor": "white",
      "::placeholder": {
        color: "#979797",
      },
      ":disabled": {
        color: "#424242",
      },
    },
    invalid: {
      color: "#EF372A",
      iconColor: "#EF372A",
    },
  },
  HBW210: {
    base: {
      "color": "#424242",
      "fontFamily": "Libre Franklin, sans-serif",
      "fontSize": "16px",
      "lineHeight": "24px",
      "backgroundColor": "white",
      "::placeholder": {
        color: "#979797",
      },
      ":disabled": {
        color: "#424242",
      },
      "iconColor": "#9e9e9e",
    },
    invalid: {
      color: "#EF372A",
      iconColor: "#EF372A",
    },
  },
};
